import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Grid, Divider } from '@material-ui/core'

import { usePositionHandler } from '~/containers/PositionHandler'

import api from '~/api'
import track from '~/track'
import StoreItemEcommerce from './StoreItemEcommerce'
import { EcommerceContext } from './DrawerEcommerce'
import { OnlineStoreContext } from '../OnlineStorePage'

export function trackApi(data, product, store, config, position) {
  api.clickTrack({
    gtin: product && (product.gtin || product[0].gtin),
    productName: product && (product.name || product[0].name),
    name: store && store.name ? store.name : 'all',
    cnpj: store && store.cnpj ? store.cnpj : '00000000000000',
    brand: config.isOndetem ? product.brand : null,
    user: position?.user,
    ...data,
  })
}

export default function ItemEcommerce({
  store,
  product,
  showValue,
  divider,
  handleLogger,
  isManually,
  configEcommerce,
}) {
  const position = usePositionHandler()
  const location = useLocation()

  const [isLoadingNewOffers, setIsLoadingNewOffers] = useState(false)
  const [newOffersSameStore, setNewOffersSameStore] = useState([])

  const ecommerceContext = useContext(EcommerceContext)
  const onlineStoreContext = useContext(OnlineStoreContext)

  const context = ecommerceContext ? ecommerceContext : onlineStoreContext

  const { mergeOtherOffers, setMergeOtherOffers } = context

  const onSearchOtherOffers = async () => {
    const { brandName } = configEcommerce

    trackApi({ event: 'ecommerce', brandName }, product, store, configEcommerce, position)

    track('comprarOnline', {
      category: 'produto',
      name: product?.name,
    })

    try {
      setIsLoadingNewOffers(true)

      const response = await api.ecommerceGoogle(product?.gtin, store?.offerId, position?.user?.city, {
        widget: configEcommerce,
        location,
      })

      setNewOffersSameStore([...newOffersSameStore, ...response.offers])
    } catch (err) {
      console.error('🚀 ~ onSearchOtherOffers ~ err:', err)
    } finally {
      setIsLoadingNewOffers(false)
    }
  }

  useEffect(() => {
    if (newOffersSameStore.length > 0) {
      setMergeOtherOffers([...mergeOtherOffers, ...newOffersSameStore])
    }
  }, [newOffersSameStore])

  useEffect(() => {
    return () => setMergeOtherOffers([])
  }, [])

  return (
    <Grid>
      <StoreItemEcommerce
        store={store}
        product={product}
        showValue={showValue}
        isManually={isManually}
        handleLogger={handleLogger}
        isLoadingNewOffers={isLoadingNewOffers}
        offersSameStore={newOffersSameStore}
        onSearchOtherOffers={onSearchOtherOffers}
        configEcommerce={configEcommerce}
      />
      {newOffersSameStore?.map((offerStore, index) => {
        return (
          <React.Fragment key={index}>
            <Divider style={{ marginInline: 16 }} />
            <StoreItemEcommerce
              store={offerStore}
              product={product}
              showValue={showValue}
              isManually={isManually}
              handleLogger={handleLogger}
              offersSameStore={newOffersSameStore}
              onSearchOtherOffers={onSearchOtherOffers}
              configEcommerce={configEcommerce}
            />
          </React.Fragment>
        )
      })}

      {divider && (
        <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
      )}
    </Grid>
  )
}
